<template>
  <!--
    	作者：wangxw
    	时间：2019-10-26
    	描述：产品分类-修改
    -->
  <el-dialog :title="getTitle" :visible.sync="dialogVisible" @close="dialogFormVisible"
             :close-on-click-modal="false"
             :close-on-press-escape="false">
    <el-form size="small" :model="form" :rules="formRules" ref="form">
      <el-form-item :label="getParentLabel" :label-width="formLabelWidth" prop="parentId" v-if="form.level">
        <span>{{ form.parentLabel }}</span>
      </el-form-item>
      <el-form-item :label="getNameLabel + '名称'" prop="name" :label-width="formLabelWidth">
        <el-input v-model="form.name" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item :label="getNameLabel + '图片'" prop="imageId" :label-width="formLabelWidth">
        <el-row>
          <el-button type="primary" @click="openUpload">选择图片</el-button>
          <div v-if="form.imageId!=''" class="img">
            <img :src="filePath" width="100" height="100"/>
          </div>
        </el-row>
      </el-form-item>
      <el-form-item :label="getNameLabel + '排序'" prop="sort" :label-width="formLabelWidth">
        <el-input v-model.number="form.sort" autocomplete="off"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible">取 消</el-button>
      <el-button type="primary" @click="addUser" :loading="loading">确 定</el-button>
    </div>
    <!--上传图片组件-->
    <Upload v-if="isupload" :isupload="isupload" @returnImgs="returnImgsFunc">上传图片</Upload>
  </el-dialog>
</template>

<script>
import CropApi from '@/api/crop.js'
import Upload from '@/components/file/Upload'
import SupplierApi from '@/api/supplier.js'
// import Treeselect from '@riophae/vue-treeselect'
// import '@riophae/vue-treeselect/dist/vue-treeselect.css'


export default {
  components: {
    Upload,
    // Treeselect
  },
  data () {
    return {
      form: {
        id: 0,
        parentId: 0,
        parentLabel: '',
        level: 0,
        levelType: 0,
        name: '',
        imageId: '',
        sort: ''
      },
      filePath: '',
      formRules: {
        name: [{
          required: true,
          message: '请输入名称',
          trigger: 'blur'
        }],
        sort: [{
          required: true,
          message: '排序不能为空'
        }, {
          type: 'number',
          message: '排序必须为数字'
        }]
      },
      /*左边长度*/
      formLabelWidth: '120px',
      /*是否显示*/
      dialogVisible: false,
      loading: false,
      /*是否上传图片*/
      isupload: false,
      categoryData: []
    }
  },
  props: ['open_edit', 'editform'],
  computed: {
    // getTreeOptions () {
    //   let treeOptions = [{
    //     id: '0',
    //     name: '顶级分类'
    //   }]
    //   treeOptions = treeOptions.concat(this.editform.catList)
    //   return treeOptions
    // }
    getTitle () {
      let text = ''
      if (this.form.level === 0) {
        text = '修改分类'
      } else if (this.form.level === 1) {
        text = '修改作物'
      } else if (this.form.level === 2) {
        text = '修改防治对象'
      }
      return text
    },
    getParentLabel () {
      let text = ''
      if (this.form.level === 1) {
        text = '所属分类'
      } else if (this.form.level === 2) {
        text = '所属作物'
      }
      return text
    },
    getNameLabel () {
      let text = ''
      if (this.form.level === 0) {
        text = '分类'
      } else if (this.form.level === 1) {
        text = '作物'
      } else if (this.form.level === 2) {
        text = '防治对象'
      }
      return text
    }
  },
  created () {
    this.dialogVisible = this.open_edit
    console.log(this.editform.model)
    this.form.id = this.editform.model.id
    this.form.parentId = this.editform.model.parentId
    this.form.parentLabel = this.editform.model.parentLabel || ''
    this.form.level = this.editform.model.level || 0
    this.form.levelType = this.editform.model.levelType || 0
    this.form.imageId = this.editform.model.imageId
    this.form.name = this.editform.model.name
    this.form.sort = this.editform.model.sort
    this.filePath = this.editform.model.imagePath
    this.getSupplierCategory()
  },
  methods: {
    normalizer (node) {
      if (node.children && !node.children.length) {
        delete node.children
      }
      return {
        id: node.id,
        label: node.name,
        children: node.children
      }
    },
    getSupplierCategory () {
      let self = this
      let Params = {}
      SupplierApi.Category(Params, true)
        .then(res => {
          self.categoryData = res.data
        })
        .catch(error => {

        })
    },
    /*修改用户*/
    addUser () {
      let self = this
      let params = self.form
      self.$refs.form.validate((valid) => {
        if (valid) {
          self.loading = true
          CropApi.cropEdit(params, true).then(data => {
            self.loading = false
            self.$message({
              message: '修改成功',
              type: 'success'
            })
            self.dialogFormVisible(true)
          }).catch(error => {
            self.loading = false
          })
        }
      })
    },
    /*关闭弹窗*/
    dialogFormVisible (e) {
      if (e) {
        this.$emit('closeDialog', {
          type: 'success',
          openDialog: false
        })
      } else {
        this.$emit('closeDialog', {
          type: 'error',
          openDialog: false
        })
      }
    },
    /*上传*/
    openUpload (e) {
      this.type = e
      this.isupload = true
    },
    /*获取图片*/
    returnImgsFunc (e) {
      if (e != null && e.length > 0) {
        this.filePath = e[0].filePath
        this.form.imageId = e[0].fileId
      }
      this.isupload = false
    },

  }
}
</script>

<style>
.img {
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/product/crop/Edit.vue